/**
 * Метаданные сборки. `version`/`commit`/`builtAt` подставляются на этапе сборки
 * через `define` в vite.config.ts (и заглушками в vitest.config.ts — см. комментарий там).
 */
export const APP = {
  version: __APP_VERSION__,
  commit: __APP_COMMIT__,
  builtAt: __APP_BUILT_AT__,
  apiBase: '/api',
} as const
